import { useEffect, useRef } from "react";

const USER_ACTIVITY_EVENTS = ["mousemove", "mousedown", "scroll", "keydown", "touchstart", "wheel"];

export function useUserActivityTracking() {
  const lastUserActivityAtRef = useRef(Date.now());

  useEffect(() => {
    const markUserActivity = () => {
      lastUserActivityAtRef.current = Date.now();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        markUserActivity();
      }
    };

    USER_ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, markUserActivity);
    });
    window.addEventListener("focus", markUserActivity);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      USER_ACTIVITY_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, markUserActivity);
      });
      window.removeEventListener("focus", markUserActivity);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return lastUserActivityAtRef;
}
